package com.bikompanion.data.gbfs

import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsStationInformationResponse(
    val data: GbfsStationInformationData,
)
